import { Component, Input, OnChanges } from '@angular/core';
import { DatePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { BoxSectionComponent } from '@atoms/box-section/box-section.component';
import { ButtonComponent } from '@atoms/button/button.component';
import { IconComponent } from '@atoms/icon/icon.component';
import { ThousandsPipe } from '@pipes/thousands.pipe';
import { CarItem } from '@models/car.model';
import { ModalDirective } from '@directives/modal.directive';

@Component({
  selector: 'app-car-detail-info-boxes',
  imports: [DatePipe, TranslateModule, BoxSectionComponent, ButtonComponent, IconComponent, ThousandsPipe, ModalDirective],
  templateUrl: './car-detail-info-boxes.component.html',
  styleUrl: './car-detail-info-boxes.component.scss',
})
export class CarDetailInfoBoxesComponent implements OnChanges {
  @Input() car?: CarItem;
  public classes: string = '';

  ngOnChanges(): void {
    if (!this.car) return;
    if (this.car.factoryWarrantyDate || (this.car.factoryWarrantyKm && this.car.model.lastServiceBookDate !== null && this.car.model.lastServiceBookKm !== null)) {
      this.classes = 'car-detail__info-boxes--three-columns';
    } else if (this.car.factoryWarrantyDate || this.car.factoryWarrantyKm || (this.car.model.lastServiceBookDate !== null && this.car.model.lastServiceBookKm !== null)) {
      this.classes = 'car-detail__info-boxes--two-columns';
    } else {
      this.classes = 'car-detail__info-boxes--one-column';
    }
    /*if ((this.car.factoryWarrantyDate || this.car.factoryWarrantyKm) && this.car.webComment) {
      this.classes = 'car-detail__info-boxes--all';
    } else if (this.car.factoryWarrantyDate || this.car.factoryWarrantyKm) {
      this.classes = 'car-detail__info-boxes--warranty';
    } else if (this.car.webComment) {
      this.classes = 'car-detail__info-boxes--comment';
    }*/
  }
}
